
      
       <!-- Default box -->
       <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Cash Bank Transaction List</div> 
         <div class="row mt-2 pl-1">
           <div class="input-group col-md-8 ">   
            <div class="col">
              <div class="input-group">
                  <span class="input-group-prepend">
                      <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
                  </span>
                  <input [(ngModel)]="searchKey" (keyup)="applyFilter()" [ngClass]="{'dark-bg' : isDark }" autocomplete="off" class="form-control py-2 border-left-0  border-right-0 border" type="text" placeholder="Search">
                  <span class="input-group-append">
                    <button class="btn  border-left-0 border" type="button">
                        <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                    </button>
                  </span>            
              </div>     
            </div>
                  
          </div>
           <div class="col-md-4">
            <button class="float-right mr-4" (click)="newButtonClick()" mat-mini-fab color="accent"> <mat-icon>add</mat-icon> </button>            
           </div>      
         </div>
      
         <fieldset>
         <div class="card-body">

          <div>
          <mat-table [dataSource]="dataSource" matSort>
           
            <ng-container matColumnDef="transNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> No. </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.TransNo}} </mat-cell>
            </ng-container>
                     
            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Type </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"><span class="badge" [ngClass]="{'badge-success' : element.TransType==='Deposited', 'badge-info' : element.TransType==='Withdrawn', 'badge-warning' : element.TransType==='Transfer'}" >{{element.TransType}}</span> </mat-cell>
              </ng-container>

            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Date </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.TransDate | date :'y-MM-dd'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="fromAccount">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> From Account </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.FromAccount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="toAccount">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> To Account </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.ToAccount}} </mat-cell>
            </ng-container>
                    
            <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Description </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.Description}} </mat-cell>
              </ng-container>
                   
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> Amount </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> {{element.Amount |  number:'1.2-2'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef class="mat-cell-center"  mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
              <mat-cell *matCellDef="let element"  class="mat-cell-center"  [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-cell-center" [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
              <mat-cell *matCellDef="let row" class="mat-cell-center" [ngClass]="{'dark-bg' : isDark }">
                <button *ngIf="crud_access.read" class="btn btn-primary btn-sm  text-white" (click)=" veiwButtonClick(row)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="far fa-folder-open"></i></button>
                  <button *ngIf="crud_access.delete" class="btn btn-danger btn-sm ml-1 text-white " (click)="deleteButtonClick(row.TransNo)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>         
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="loading">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
            </ng-container>

            <ng-container matColumnDef="noData">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
            <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
          </mat-table>

          <mat-paginator [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          </div>
          
         </div>                                
         <!-- /.card-body -->

       </fieldset>

       </div>

   <script>
   
     $(function () {
     $('[data-toggle="viewTooltip"]').tooltip()
   })
   $(function () {
     $('[data-toggle="deleteTooltip"]').tooltip()
   })
   </script>
 




